<template>
	<div class="ReLeadSearchObj card" >
		<div class="iframe-container " id="iframecontainer" v-show="bIsShown || showFromStorage">
			<div class="d-flex iframe-button pt-1"><base-button @click="hideObjects()" type="danger" class="" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button></div>
			<!-- <iframe src="/data/module/mo?srv_new=1&srv_inwork=1&dSearchType=lead" style="width:100%; height:calc(100vh - 200px); flex:1 1 0%;" ref="myIframe"  />  -->

			<!-- <ReLeadSearchObjContainer style="width:100%; height:calc(100vh - 70px); flex:1 1 0%; overflow-y: scroll;" :objects="masObjects"  ref="myIframe" /> -->
			<base-input type="hidden" v-model="bufferValue"></base-input>

			<div class="ReLeadSearchObjContainer" style="width:100%; height:calc(100vh - 70px); flex:1 1 0%; overflow-y: scroll;" ref="myIframe">
				<ReLeadSearchObjFilter v-if="bIsObjects" @change="OnFilterApply" />

				<template v-if="bIsObjects">
					<h3 class="text-center" v-if="bIsObjects.length==0">Ничего не найдено</h3>
					<h6 class="mt-3 mb-0 text-center">Объектов найдено: {{this.masObjects_total}}</h6>
					<ReLeadTableCopy :objData="ApiData" :objects="masObjects" v-model="dSearchType" @change="OnFilterApply()"/>
					<!-- <ReLeadTable :objData="ApiData" :objects="masObjects" v-model="dSearchType" @change="OnFilterApply()"/> -->
				</template>
				
				<Pagination v-if="bIsObjects" class="pagination-BG" :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
					:type="'info'" 
					:total="parseInt(masObjects_total)" 
					:perPage="parseInt(10)"
					:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
					:pClick="pClick">
				</Pagination>

			</div>

		</div>



		<div class="inline-flex mb-2">
			<base-button @click="showObjects()" type="primary" class="" simple>Показать выбор объектов</base-button>
		</div>
		<div v-if="value!=''" class="ml-1">
			<h6>Выбранные объекты: </h6>
			<ul class="list-unstyled result-marker" v-if="masObjects && masObjects.length>0">
				<li v-for="(obj,index) in masObjects" class="row mx-0 objitem" :key="index">
					<div class="col">
						<div class="row align-items-center objitem-text">
							<span v-if="obj.promo" class="badge badge-pill badge-primary">промо</span>
							<span>id: <b>{{ obj.id }}</b>, </span>
							<span v-if="obj.price && obj.price!=''">цена: <b>{{ $GVO.number_format(obj.price,0,'.',' ') }} ₽</b>, </span>
							<span v-if="obj.square && obj.square!=''">площадь: <b>{{ obj.square }} м2</b>, </span>
							<span v-if="obj.dealType && obj.dealType!=''">тип сделки: <b>{{ obj.dealType }}</b>, </span>
							<span v-if="obj.objectType && obj.objectType!=''">тип объекта: <b>{{ obj.objectType }}</b>, </span>
							<span v-if="obj.roomsCountTotal && obj.roomsCountTotal!=''">количество комнат: <b>{{ obj.roomsCountTotal }}</b>, </span>
							<span v-if="obj.landSquare && obj.landSquare!=''">площадь участка: <b>{{ obj.landSquare }} м2</b>, </span>
							<!-- <span>адрес: <b>{{ obj.address }}</b>, </span> -->
							<span v-if="obj.address && obj.address!=''"><b>адрес:</b> {{ obj.address }}</span>
							<span v-if="obj.MapAddress && obj.MapAddress.address.inputText!=''"><b>адрес:</b> {{ obj.MapAddress.address.inputText }}</span>
						</div>
							
						<div class="row align-items-center" v-if=" bIsNew ">
							<span v-if="obj.service_agent_fio && obj.service_agent_fio!=''">Ответственный за услугу: <b>{{ obj.service_agent_fio }}</b>, </span> 
							<span v-if="!bIsNew"> лид не сохранён, звонить и писать по нему нельзя</span>
							<div class="d-flex mr-3 ml-2 align-items-center" v-if="bIsNew && obj.staff_info_mobile_phone !=''">
								<span v-if="obj.staff_info_mobile_phone && obj.staff_info_mobile_phone !=''" class="mr-2">Моб.: {{ obj.staff_info_mobile_phone }}</span>
								<RePhoneCallButton
									v-if="obj.staff_info_mobile_phone && obj.staff_info_mobile_phone !=''"
									:phone="obj.staff_info_mobile_phone"
									:lead_id="$route.params.lead_id"
									
								/>
								
							</div>
							
							<div class="d-flex align-items-center" v-if="bIsNew &&  obj.staff_info_internal_phone !=''">
								<span v-if="obj.staff_info_internal_phone && obj.staff_info_internal_phone !=''" class="mr-2 ml-2">Доб.: {{ obj.staff_info_internal_phone }}</span>
								<RePhoneCallButton
									v-if="obj.staff_info_internal_phone && obj.staff_info_internal_phone !=''"
									:phone="obj.staff_info_internal_phone"
									:lead_id="$route.params.lead_id"
								/>
							</div>
							
							<template v-if="bIsNew && showThisAfterDataFetched">
								<ReLeadMessageButton 
									:staff_name="obj.service_agent_fio"
									:staff_code="obj.service_agent_id"
									:obj_type="'LEAD'" 
									:obj_id="$route.params.lead_id"
									:obj_name="'callcenter'"
									messageSent="Вопрос клиента: "
									:bShowSendBtn="false"
									@change="(value)=>objectMessage(obj, value)" 		
								/>
							</template>
						</div>
						
						
					</div>
					<div class="d-flex align-items-start">
						<base-button @click="delObject(obj.id)" type="danger" class="btn mt-0" simple><i class="tim-icons icon-trash-simple"></i> Удалить объект</base-button>
						<!-- <base-button @click="delObject(obj.id)" type="danger" class="btn-icon" simple><i class="tim-icons icon-trash-simple"></i></base-button> -->
					</div>
				</li> 
			</ul> 
		</div>
	</div>
</template>

<script>
	import { Select, Option, Button } from 'element-ui';
	import messageTransport from "src/mixins/messageTransport.js";
	// import ReLeadSearchObjContainer from "src/our_components/ReLeadSearchObjContainer.vue";
	import RePhoneCallButton from "src/our_components/RePhoneCallButton.vue";
	import ReLeadMessageButton from "src/our_components/ReLeadMessageButton.vue";
	import ReLeadSearchObjFilter from 'src/our_components/ReLeadSearchObjFilter.vue';
	import Pagination from 'src/our_components/RePagination';
	// import ReLeadTable from 'src/our_components/ReLeadTable.vue';
	import ReLeadTableCopy from 'src/our_components/ReLeadTableCopy.vue';
	// import {eventEmitter} from "src/plugins/globalComponents.js";
	
	// import ReLeadSearchObjFilter from 'src/our_components/ReLeadSearchObjFilter.vue';
	// import Pagination from 'src/our_components/RePagination';
	// import ReLeadTable from 'src/our_components/ReLeadTable.vue';

	export default {
		name: 'ReLeadSearchObj',
		mixins:[
			messageTransport,
		],
		components: {
			[Option.name]: Option,
			[Select.name]: Select,
			[Button.name]: Button,
			// ReLeadSearchObjContainer,
			RePhoneCallButton,
			ReLeadMessageButton,
			ReLeadSearchObjFilter,
			Pagination,
			// ReLeadTable,
			ReLeadTableCopy,
		},
		props: {
			value: [Array, String],
			placeholder:{
				type: String,
				default: '',
			},
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			objects: Array,
			operationType: String,
			// messageSent: String,
			
		},
		data () {
			return {
				ver: 1,
				// ApiData:[],
				masObjects:[],
				bufferValue: null,
				bIsShown: false,
				leadId: '',

				ApiData: [],
				bShowFilter: false,
				objGetParams: {},
				masObjects_total: 0,
				count2page: 12,
				fullscreenLoading: false,
				dSearchType: 'mobj',
				bIsObjects:true,
				showFromStorage: false,
				objStaffExtra:{},
				showThisAfterDataFetched: true,
			}
		},
		watch: {
			value(val){
				this.bufferValue = this.$GVO.unlinkObject(val);
				this.getObjecsInArray();
			},
			bufferValue(val){
				this.bufferValue = val;
				this.$emit("input", this.bufferValue);
				// console.log('object Change')
				if (/*this.masObjects.length > 0*/ this.bufferValue !='') {
					this.hideObjects();
				}
			},
			
			// 'objStaffExtra': {
			// 	handler: function (newVal, oldVal) {
			// 		console.log('newVal', newVal);   
			// 	},
			// 	deep: true
			// },
			// objStaffExtra: function (newVal, oldVal) {
			// 	console.log('newVal', newVal);  
			// }
			
			
		},
		computed: {
			bIsNew: function(){
				if(location.pathname.indexOf('/data/callcenter/add') === -1){
					return true;
				}
				return false;
			},

		},
		methods: {
			/*
				https://stackoverflow.com/questions/69784876/how-to-pass-data-from-ifram-to-parent
				http://blog.pixelastic.com/2017/09/12/sending-data-to-an-iframe-with-vue-js/
				https://laracasts.com/discuss/channels/vue/vuejs-iframe

			*/
			objectMessage(obj,value){
				this.$set(obj, 'leadMessage', {text: value})
				this.bufferValue = JSON.stringify(this.masObjects);
				this.getObjecsInArray();
			},
			// GoToEdit(){
			// 	this.$router.push({path: '/data/module/mo?srv_new=1&srv_inwork=1&dSearchType=lead'});
			// 	// this.$router.push({path: '/data/module/mo?srv_new=1&srv_inwork=1&dSearchType=lead'});
			// },
			message_LeadObjects(data){
				//console.log('message_LeadObjects',data);
				if(data!='' && data!=undefined){this.bufferValue = JSON.stringify(data);}
			},
			getObjecsInArray(){
				// this.masObjects = JSON.parse(this.value);
				if(this.value!='' && this.value!=undefined){
					this.masObjects = JSON.parse(this.value);
					for (let i = 0; i < this.masObjects.length; i++) {
						// this.operationType = this.masObjects[0].dealType;
						/*
						if(typeof this.objStaffExtra[this.masObjects[i].service_agent_id] == 'undefined'){
							this.$GVO.ApiCall('staff.GET_STAFF_EXTRA_DATA',{flt:{'code':this.masObjects[i].service_agent_id}})
							.then((objApi) => {
								if(objApi.success === true){
									this.objStaffExtra[this.masObjects[i].service_agent_id] = objApi.data[0];
									// console.log('this.objStaffExtra.service_agent_id]',this.objStaffExtra[this.masObjects[i].service_agent_id]);
									this.forceRender(); // перерисовать компонент с отправкой сообщения, после того как данные пришли в objStaffExtra 
								}
							}).catch(errorObjApi => {console.log(errorObjApi);});
						}
						*/
					}
				}
			},
			async forceRender(){
				//изначально showThisAfterDataFetched трушный, меняем на false и ждем тик
				this.showThisAfterDataFetched = false;
				await this.$nextTick();

				// возвращаем трушность на v-if для отправки сообщений (здесь данные в objStaffExtra уже получены)
				this.showThisAfterDataFetched = true;
			},
			hideObjects(){
				this.bIsShown = false;
				// this.showObj = false;
				// let iframecontainer = document.getElementById('iframecontainer');
				// if(iframecontainer) {
				// 	iframecontainer.classList.add("iframe-closed");
				// } 
				sessionStorage.removeItem('lead-objects-open');
				this.showFromStorage = false;
				
			},
			showObjects(){
				// let iframecontainer = document.getElementById('iframecontainer');
				// if(iframecontainer) {
				// 	iframecontainer.classList.remove("iframe-closed");
				// }
				this.bIsShown = true;
				this.saveLocalSettings();
			},
			getLeadId(){
				this.leadId = typeof this.$route.params.lead_id == 'undefined'?'0':this.$route.params.lead_id;

			},
			delObject(objid){
				//объекты сохраняются в sessionStorage (проблема сохранения чекбоксов внутри компонента с таблицей), поэтому их нужно удалить из sessionStorage тоже!
				let sessiondata = [];
				sessiondata = JSON.parse(sessionStorage.getItem("lead-search-objects"))==null?[]:JSON.parse(sessionStorage.getItem("lead-search-objects"));
				const filtered = sessiondata.filter(item => item.id != objid);
				sessionStorage.setItem('lead-search-objects', JSON.stringify(filtered));

				for(let i = 0; i < this.masObjects.length; i++){
					if(this.masObjects[i].id == objid){
						//console.log('objid',this.masObjects[i].id);
						this.masObjects = this.masObjects.filter(item => item.id != objid);
					}
				}
				this.bufferValue = JSON.stringify(this.masObjects);
				//console.log('objid',sessiondata);
			},
			saveLocalSettings(){
				sessionStorage.setItem('lead-objects-open', true);
				// this.showFromStorage = true;
			},
			getApiData(){
				//console.log('mo_allbuildings getApiData = MyObj.GET');
				this.ApiData = [];
				let filter = {};
				this.objGetParams = this.$GVO.GetAllGet();
				//console.log('mo_allbuildings objGetParams 82 line ',this.$GVO.unlinkObject(this.objGetParams));
				// console.log('filter', this.objGetParams);

				this.objGetParams.dSearchType = this.dSearchType;
				if (!this.$GVO.isEmpty(this.objGetParams)) {
					if(typeof this.objGetParams.dSearchType !='undefined') this.dSearchType = this.objGetParams.dSearchType;
					filter = this.$GVO.SafeParseJson(JSON.stringify(this.objGetParams));	
					// console.log('filter2', this.objGetParams);			
				} 
				
				this.$GVO.ApiCall('MyObj.GET',{flt:{...filter}})
				.then((objApi) => {
					this.masObjects_total=0;
					if(objApi.success === true){
						if(objApi.data.length > 0){
							this.ApiData = objApi.data;
							if(objApi.total!=undefined) { 
								// this.masObjects_total=objApi.countpage;
								this.masObjects_total=objApi.total; 
							}
						}
					}else{
						this.ApiData = [];
						
					}
				}).catch(errorObjApi => {this.ApiData = []; this.masObjects_total=0; console.error(errorObjApi);});
			},
			OnFilterApply(strItogGetParams){ // применяет параметры из фильтра и запускает запрос к АПИ
				if(strItogGetParams == undefined){
					// var queryParams = new URLSearchParams(window.location.search);
					// history.replaceState(null, null, "?"+queryParams.toString());
					// this.objGetParams = this.$GVO.GetAllGet();

					let objItogGetParams = this.$GVO.GetAllGet();
					// let objItogGetParams = this.objGetParams; 
					// console.log('objItogGetParams', objItogGetParams);
					if(typeof objItogGetParams.dSearchType !='undefined') {
							if(['mobj','lead'].indexOf(objItogGetParams.dSearchType)==-1)objItogGetParams.dSearchType = 'mobj';
						}
					if(typeof objItogGetParams.dSearchType !='undefined' && this.dSearchType != objItogGetParams.dSearchType) {
						objItogGetParams.dSearchType = this.dSearchType;
						if(typeof objItogGetParams['p'] != 'undefined'){
							delete objItogGetParams['p'];
						}
					}
					
					strItogGetParams = this.$GVO.ObjToQueryString(objItogGetParams).substr(1);
					//console.log('OnFilterApply++ strItogGetParams == ',strItogGetParams);
				}
				// console.log('OnFilterApply++',strItogGetParams);
				this.$router.push({path: location.pathname+'?'+strItogGetParams});
				this.getApiData();
			},
			pClick(e){
				let strItogGetParams = '';
				let objItogGetParams = this.$GVO.GetAllGet();
				objItogGetParams.p=parseInt(e);
				strItogGetParams = this.$GVO.ObjToQueryString(objItogGetParams).substr(1);
				// console.log('strItogGetParams', strItogGetParams);
				this.OnFilterApply(strItogGetParams);
			},

			// showObjSearch(data){
			// 	//console.log('bIsShown showObjSearch',this.bIsShown);
			// 	return true;
			// }
			// smth(dopParam){
			// 	if(location.pathname.indexOf('/data/callcenter/add') != -1){
			// 		console.log(dopParam.data.new_id);
			// 		// if(typeof dopParam.data.new_id != 'undefined'){
			// 		// 	location.href = '/data/callcenter/id/'+dopParam.data.new_id;
			// 		// }
					
			// 	}

			// 	// this.$router.push({path: '/data/callcenter'});
			// },

		},
		mounted(){
			// this.objGetParams = this.$GVO.GetAllGet();
			if(this.value!=''){
				this.getObjecsInArray();
				this.getLeadId();
			}
			this.showFromStorage = sessionStorage.getItem('lead-objects-open');
			let data = sessionStorage.getItem("lead-search-objects");
			//console.log('sessionStorage',sessionStorage);
			if(data!="[]" && data!=undefined){
				this.bIsShown = true;
				//console.log('bIsShown mounted',this.bIsShown);
			}

			var queryParams = new URLSearchParams(window.location.search);
			// queryParams.set("dSearchType", "mobj");
			history.replaceState(null, null, "?"+queryParams.toString());
			
			this.objGetParams = this.$GVO.GetAllGet();
			// console.log('mo_allbuildings objGetParams ',this.$GVO.unlinkObject(this.objGetParams));
			this.getApiData(); // очень нужно, и тут, и в OnFilterApply
			
		},
		created() {
			
			// this.cat_timer = setInterval(() => {

			// 	eventEmitter.$on("reload_tasks", this.reloadTasksAll);
			// 	clearTimeout(this.cat_timer);
			// }, 250);
			
			// eventEmitter.$on("showObj", this.bIsShown);
			//eventEmitter.$on("reload_tasks", this.reloadTasksAll);
		}
		
	}
</script>
<style scoped>
.ReLeadSearchObj{
	padding: 10px;
	border: 1px dashed #01B0E0;
	border-radius: 6px;
	
}
.iframe-container {
	display: flex;
	position: fixed; /** absolute*/
    width: calc(100vw - 50px);
    height: fit-content;
    background-color: inherit;
    padding: 52px 15px 15px 15px;
	box-shadow: 0px 3px 10px 0px rgba(123, 123, 123, 0.45)!important;
    border: 1px solid #9e77f3;
	border-radius: 6px;
	z-index: 2000;
	top: 0px;
	left:10px;
	/* top: -280px; */
    /* left: -280px; */
}
.iframe-closed {
	/* position: relative; */
	/* width: 0;
	height: 0; */
	display: none;
}
.iframe-opened {
	display: flex;
}
.iframe-button{
	position: absolute;
    top: 0;
    right: 15px;
}

.pagination-BG {
	background-color:#27293d;     
	margin-bottom: 0px;
    padding: 10px;
	position: absolute; bottom: 0;
}
.white-content .card:not(.card-white) .pagination-BG{
    background-color:#fff!important;
}
.ReLeadSearchObj >>> .objitem:not(:last-child) {
    border-bottom: 1px dashed rgb(1, 176, 224);
	padding-bottom: 10px;
	margin-bottom: 15px;
}
.objitem-text span {margin-right: 5px;}


.ReLeadSearchObj >>> .result-marker li::before {margin-top: 5px;}


/* @media (max-width: 1390px){
	.iframe-container {
		top: -320px;
	}
	
}
@media (max-width: 1200px){
	.iframe-container {
		top: -280px;
		left: 0;
	}
	
} */
</style>
